import { Endpoint } from '@business/api/endpoint';
import { CompactIdeaResponse } from '@business/entities/idea';
import { R } from '@core/utils/r';
import { CompactIdeaCategoryResponse, IdeaCommentResponse, IdeaId } from './../../entities/idea/IdeaResponse';
import { IdeasFormData } from '@modules/ideas/IdeasPage/IdeasPage';

export function fetchIdeas(options?: IdeasFormData) {
  const params = R.objectCompact(options);
  return Endpoint.get<CompactIdeaResponse[]>(`@makh/ideas`, { params });
}

export function createIdea(data: Partial<CompactIdeaResponse>) {
  return Endpoint.post<CompactIdeaResponse>(`@makh/ideas`, { data });
}

export function updateIdea(ideaId: IdeaId, data: Partial<CompactIdeaResponse>) {
  return Endpoint.patch<CompactIdeaResponse>(`@makh/ideas/${ideaId}`, { data });
}

export function deleteIdea(ideaId: IdeaId) {
  return Endpoint.delete<void>(`@makh/ideas/${ideaId}`);
}

export function fetchIdea(ideaId: IdeaId) {
  return Endpoint.get<CompactIdeaResponse>(`@makh/ideas/idea/${ideaId}`);
}

export function searchIdeas(search: string) {
  return Endpoint.get<CompactIdeaResponse[]>(`@makh/ideas/search-idea`, { params: { search } });
}

// Comments

export function fetchComments(options: { search?: string } = {}) {
  const params = R.objectCompact({ search: options.search });
  return Endpoint.get<IdeaCommentResponse[]>(`@makh/ideas/comments`, { params });
}

export function createComment(ideaId: IdeaId, data: Partial<IdeaCommentResponse>) {
  return Endpoint.post<IdeaCommentResponse>(`@makh/ideas/comment/${ideaId}`, { data });
}

export function updateComment(id: string, data: Partial<IdeaCommentResponse>) {
  return Endpoint.patch<IdeaCommentResponse>(`@makh/ideas/comment/${id}`, { data });
}

export function deleteComment(id: string) {
  return Endpoint.delete<void>(`@makh/ideas/comment/${id}`);
}

export function fetchComment(id: string) {
  return Endpoint.get<IdeaCommentResponse>(`@makh/ideas/comment/${id}`);
}

export function postVote(ideaId: IdeaId, detailPage?: boolean) {
  return Endpoint.post<CompactIdeaResponse>(`@makh/ideas/vote/${ideaId}`, { data: { detailPage } });
}

export function fetchCategories() {
  return Endpoint.get<CompactIdeaCategoryResponse[]>(`@makh/ideas/categories`, {});
}
